import React, { useState } from 'react';
import { Nav, DropdownToggle, DropdownMenu, DropdownItem, Dropdown } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CoreTracking } from '../../../../models/CoreTracking';
import MapAsmUserTrackingWizard from './MapAsmUserTrackingWizard';
import RestoreAsmUserTrackingWizard from './RestoreAsmUserTrackingWizard';
import InactivateAsmUserTrackingWizard from './InactivateAsmUserTrackingWizard';
import { useTranslation } from 'react-i18next';

enum AsmUserTrackingOperation {
    None = 0,
    Inactivate = 1,
    Restore = 2,
    Map = 3,
}

interface AsmUserTrackingOperationsMenuProps {
    tracking: CoreTracking
    onClose?: (success: boolean) => void
    disabled?: boolean
}

const AsmUserTrackingOperationsMenu: React.FC<AsmUserTrackingOperationsMenuProps> = (props) => {
    const { t } = useTranslation(["schoolAdministration"])
    const [action, setAction] = useState(AsmUserTrackingOperation.None);
    const [dropdownOpen, setDropdownOpen] = useState(false);

    if (!isAsmUserTracking(props.tracking)) {
        return null;
    }

    const close = (success: boolean) => {
        setAction(AsmUserTrackingOperation.None);

        if (props.onClose) {
            props.onClose(success);
        }
    }

    return <React.Fragment>
        <Nav className="right">
            <Dropdown nav isOpen={dropdownOpen} toggle={() => setDropdownOpen(!dropdownOpen)}>
                <DropdownToggle nav style={{ display: 'inline' }}>
                    <FontAwesomeIcon icon="ellipsis" className="icon" title={t('trackingOperations.title', { ns: 'schoolAdministration'})} />
                </DropdownToggle>
                <DropdownMenu>
                    {props.tracking.active && <DropdownItem onClick={() => setAction(AsmUserTrackingOperation.Map)} disabled={props.disabled}>{t('trackingOperations.asm.map.menuName', { ns: 'schoolAdministration'})}</DropdownItem>}
                    {props.tracking.active && <DropdownItem onClick={() => setAction(AsmUserTrackingOperation.Inactivate)} disabled={props.disabled}>{t('trackingOperations.asm.inactivate.menuName', { ns: 'schoolAdministration' })}</DropdownItem>}
                    {!props.tracking.active && <DropdownItem onClick={() => setAction(AsmUserTrackingOperation.Restore)} disabled={props.disabled}>{t('trackingOperations.asm.restore.menuName', { ns: 'schoolAdministration' })}</DropdownItem>}
                </DropdownMenu>
            </Dropdown>
        </Nav>
        {action === AsmUserTrackingOperation.Map && <MapAsmUserTrackingWizard tracking={props.tracking} close={close} />}
        {action === AsmUserTrackingOperation.Inactivate && <InactivateAsmUserTrackingWizard tracking={props.tracking} close={close} />}
        {action === AsmUserTrackingOperation.Restore && <RestoreAsmUserTrackingWizard tracking={props.tracking} close={close} />}
    </React.Fragment>;
}

export const isAsmUserTracking = (tracking: CoreTracking): boolean => {
    return tracking.sourceName === 'AppleSchoolManager';
}

export default AsmUserTrackingOperationsMenu;
